import { connect } from 'react-redux';

import {
  proCountSelector,
  proCountGroupSelector,
  prosSelector,
  prosGroupSelector,
} from 'modules/marketing-pages/duck/selectors';
import type { RootState } from 'store/types';

import ListPros, { ListProsProps } from './ListPros';

const mapState = (state: RootState, props: ListProsProps) => ({
  proCount: props.isGroupCity ? proCountGroupSelector(state) : proCountSelector(state),
  pros: props.isGroupCity ? prosGroupSelector(state) : prosSelector(state),
});

// TODO Use ConnectedProps from react-redux after version update
export type PropsFromRedux = ReturnType<typeof mapState>;
export default connect(mapState)(ListPros);
